import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AuditLog {
  id: number;
  requestType: string | null;
  requestEndpoint: string | null;
  userId: number | null;
  studentId: number | null;
  success: boolean;
  action: string | null;
  requestParams: any | null;
  returned: any | null;
  eventType: string | null;
  reason: string | null;
  disclosedTo: string | null;
  consentVerified: boolean | null;
  ipAddress: string | null;
  userAgent: string | null;
  timestamp: string;
  user?: {
    id: number;
    first_name: string;
    last_name: string;
    preferredName: string;
    email: string;
  };
}

export interface AuditLogResponse {
  total: number;
  logs: AuditLog[];
}

export interface AuditLogFilters {
  studentId?: number;
  userId?: number;
  eventType?: string;
  success?: boolean;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

@Injectable({ providedIn: 'root' })
export class AuditLogService {
  private http = inject(HttpClient);

  getLogs(filters: AuditLogFilters = {}): Observable<AuditLogResponse> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== '') {
        params = params.set(key, String(val));
      }
    });
    return this.http.get<AuditLogResponse>('/api/audit-logs', { params });
  }
}
